export default __webpack_public_path__ + "static/slider-5-210d82a3aac9b80883a97737e8f565ff.jpg";